import React from "react";

import { AuthenticationCard, IAuthenticationCardProps } from "../Components/AuthenticationCard";
import DiamondIcon from "../Components/DiamondIcon";
import VersionFooter from "../Components/VersionFooter";

export interface IBaseGemAuthenticationCardProps extends Pick<IAuthenticationCardProps, "salutation"> {
  /** The form component to be displayed within the card which obtains the session token. */
  AuthenticationForm: React.FC;
}

/** The core ui surface used to authenticate with the GEM api and obtain a session token.
 * @remarks Establishes the immediate lead to load if one is detected in the url path query params.
 */
const BaseGemAuthenticationCard: React.FC<IBaseGemAuthenticationCardProps> = ({ salutation, AuthenticationForm }) => {
  return AuthenticationCard({
    headerIcon: DiamondIcon({}),
    headerText: "Gem",
    salutation,
    footer: VersionFooter({}),
    children: [AuthenticationForm({})]
  });
};

export default BaseGemAuthenticationCard;
